import CONFIG from '../Config/index';
import { create } from 'apisauce';

export class Backend {

  constructor(authData) {
    const headers = {
      Accept: 'application/json'
    };

    if (authData && authData.access_token) {
      headers.Authorization = `Bearer ${authData.access_token}`;
    }

    this.api = create({
      baseURL: CONFIG.backend.url,
      headers
    });

    // if (DebugConfig.enableReactotron) {
    //     this.api.addMonitor(Reactotron.apisauce);
    // }
  }

  get(path, params, headers) {
    return this.api.get(path, params, { headers: headers || {} });
  }

  post(path, data, headers?: any = {}) {
    return this.api.post(path, data, { headers });
  }

  put(path, data, headers?: any = {}) {
    return this.api.put(path, data, { headers });
  }

  delete(path: string, params?: any, headers?: any = {}) {
    return this.api.delete(path, params, { headers });
  }

  postForm(path, data, headers = {}) {
    const formBody = [];
    for (const property in data) {
      if (data.hasOwnProperty(property)) {
        const encodedValue = data[property];
        formBody.push(`${property}=${encodedValue}`);
      }
    }
    const formString = formBody.join("&");
    headers['Content-Type'] = 'application/x-www-form-urlencoded';

    console.log(headers);

    return this.post(path, formString, headers);
  }

  upload(path: string, data: any, progressHandler: (progressEvent: any) => void) {
    const formData = new FormData();
    const keys = Object.keys(data);
    for(const key of keys) {
      formData.append(key, data[key]);
    }
    return this.api.post(path, formData, { onUploadProgress: progressHandler });
  }
}

export default Backend;




// WEBPACK FOOTER //
// ./src/App/Services/Backend.js